import { requestApi } from '../util/network'

// 获取店铺配送信息
export const getO2oInfo =
    () =>
      requestApi(
        '/seller_o2o/get_o2o_info',
        'POST',
        {

        },
        'seller'
      )
// 修改店铺配送信息
export const editO2oInfo =
    (storeO2oReceipt, storeO2oReceiptLimit, storeO2oComplaintFine, storeO2oDistributeType, storeO2oDistance, storeO2oFee, storeO2oOpenStart, storeO2oOpenEnd, storeO2oAutoReceipt, storeO2oAutoDeliver, storeO2oMinCost, storeO2oRejectTime) =>
      requestApi(
        '/seller_o2o/edit_o2o',
        'POST',
        {
          'store_o2o_receipt': storeO2oReceipt,
          'store_o2o_receipt_limit': storeO2oReceiptLimit,
          'store_o2o_complaint_fine': storeO2oComplaintFine,
          'store_o2o_distribute_type': storeO2oDistributeType,
          'store_o2o_distance': storeO2oDistance,
          'store_o2o_fee': storeO2oFee,
          'store_o2o_open_start': storeO2oOpenStart,
          'store_o2o_open_end': storeO2oOpenEnd,
          'store_o2o_auto_receipt': storeO2oAutoReceipt,
          'store_o2o_auto_deliver': storeO2oAutoDeliver,
          'store_o2o_min_cost': storeO2oMinCost,
          'store_o2o_reject_time': storeO2oRejectTime
        },
        'seller'
      )

// 获取店铺配送员列表
export const getDistributorList =
    () =>
      requestApi(
        '/seller_o2o_distributor/index',
        'POST',
        {

        },
        'seller'
      )

// 获取店铺配送信息
export const getDistributorInfo =
    (id) =>
      requestApi(
        '/seller_o2o_distributor/info',
        'POST',
        {
          'id': id
        },
        'seller'
      )

// 新增发票
export const addDistributor =
    (data) =>
      requestApi(
        '/seller_o2o_distributor/add',
        'POST',
        {
          'o2o_distributor_name': data.o2o_distributor_name,
          'o2o_distributor_realname': data.o2o_distributor_realname,
          'o2o_distributor_phone': data.o2o_distributor_phone,
          'o2o_distributor_email': data.o2o_distributor_email,
          'o2o_distributor_remark': data.o2o_distributor_remark,
          'o2o_distributor_introduce': data.o2o_distributor_introduce,
          'o2o_distributor_state': data.o2o_distributor_state,
          'o2o_distributor_avatar_value': data.o2o_distributor_avatar,
          'o2o_distributor_password': data.o2o_distributor_password
        },
        'seller'
      )
// 编辑配送员
export const editDistributor =
    (data, id) =>
      requestApi(
        '/seller_o2o_distributor/edit',
        'POST',
        {
          'id': id,
          'o2o_distributor_realname': data.o2o_distributor_realname,
          'o2o_distributor_phone': data.o2o_distributor_phone,
          'o2o_distributor_email': data.o2o_distributor_email,
          'o2o_distributor_remark': data.o2o_distributor_remark,
          'o2o_distributor_introduce': data.o2o_distributor_introduce,
          'o2o_distributor_state': data.o2o_distributor_state,
          'o2o_distributor_avatar_value': data.o2o_distributor_avatar,
          'o2o_distributor_password': data.o2o_distributor_password
        },
        'seller'
      )
// 删除配送员
export const delDistributor =
    (id) =>
      requestApi(
        '/seller_o2o_distributor/del',
        'POST',
        {
          'id': id
        },
        'seller'
      )

// 配送员结算
export const getBillList =
    (params) =>
      requestApi(
        '/seller_o2o_order_bill/index',
        'POST',
        {
          page: params.page,
          per_page: params.per_page
        },
        'seller'
      )
// 配送员结算
export const confirmBill =
    (bill_id, ob_seller_content) =>
      requestApi(
        '/seller_o2o_order_bill/confirm_bill',
        'POST',
        {
          bill_id: bill_id,
          ob_seller_content: ob_seller_content
        },
        'seller'
      )
// 配送员结算
export const payBill =
    (data) =>
      requestApi(
        '/seller_o2o_order_bill/pay_bill',
        'POST',
        data,
        'seller',
        true
      )
// 配送员投诉
export const getComplaintList =
    (params) =>
      requestApi(
        '/seller_o2o_complaint/index',
        'POST',
        {
          page: params.page,
          per_page: params.per_page
        },
        'seller'
      )
// 配送员投诉
export const editComplaint =
    (o2o_complaint_id, content) =>
      requestApi(
        '/seller_o2o_complaint/edit',
        'POST',
        {
          o2o_complaint_id: o2o_complaint_id,
          content: content
        },
        'seller'
      )
